import { t } from "@/localization";

export default {
  AF: t("Afghanistan"),
  AX: t("Åland Islands"),
  AL: t("Albania"),
  DZ: t("Algeria"),
  AS: t("American Samoa"),
  AD: t("Andorra"),
  AO: t("Angola"),
  AI: t("Anguilla"),
  AQ: t("Antarctica"),
  AG: t("Antigua and Barbuda"),
  AR: t("Argentina"),
  AM: t("Armenia"),
  AW: t("Aruba"),
  AU: t("Australia"),
  AT: t("Austria"),
  AZ: t("Azerbaijan"),
  BS: t("Bahamas"),
  BH: t("Bahrain"),
  BD: t("Bangladesh"),
  BE: t("Belgium"),
  BZ: t("Belize"),
  BJ: t("Benin"),
  BM: t("Bermuda"),
  BT: t("Bhutan"),
  BO: t("Bolivia"),
  BA: t("Bosnia and Herzegovina"),
  BW: t("Botswana"),
  BV: t("Bouvet Island"),
  BR: t("Brazil"),
  IO: t("British Indian Ocean Territory"),
  BN: t("Brunei Darussalam"),
  BG: t("Bulgaria"),
  BF: t("Burkina Faso"),
  BI: t("Burundi"),
  KH: t("Cambodia"),
  CM: t("Cameroon"),
  CA: t("Canada"),
  CV: t("Cape Verde"),
  KY: t("Cayman Islands"),
  CF: t("Central African Republic"),
  TD: t("Chad"),
  CL: t("Chile"),
  CN: t("China"),
  CX: t("Christmas Island"),
  CC: t("Cocos (Keeling) Islands"),
  CO: t("Colombia"),
  KM: t("Comoros"),
  CG: t("Congo"),
  CD: t("Congo, The Democratic Republic of the"),
  CK: t("Cook Islands"),
  CR: t("Costa Rica"),
  CI: t("Cote D Ivoire"),
  HR: t("Croatia"),
  CU: t("Cuba"),
  CY: t("Cyprus"),
  CZ: t("Czech Republic"),
  DK: t("Denmark"),
  DJ: t("Djibouti"),
  DM: t("Dominica"),
  DO: t("Dominican Republic"),
  EC: t("Ecuador"),
  EG: t("Egypt"),
  SV: t("El Salvador"),
  GQ: t("Equatorial Guinea"),
  ER: t("Eritrea"),
  EE: t("Estonia"),
  ET: t("Ethiopia"),
  FK: t("Falkland Islands (Malvinas)"),
  FO: t("Faroe Islands"),
  FJ: t("Fiji"),
  FI: t("Finland"),
  FR: t("France"),
  GF: t("French Guiana"),
  PF: t("French Polynesia"),
  TF: t("French Southern Territories"),
  GA: t("Gabon"),
  GM: t("Gambia"),
  GE: t("Georgia"),
  DE: t("Germany"),
  GH: t("Ghana"),
  GI: t("Gibraltar"),
  GR: t("Greece"),
  GL: t("Greenland"),
  GD: t("Grenada"),
  GP: t("Guadeloupe"),
  GU: t("Guam"),
  GT: t("Guatemala"),
  GG: t("Guernsey"),
  GN: t("Guinea"),
  GW: t("Guinea-Bissau"),
  GY: t("Guyana"),
  HT: t("Haiti"),
  HM: t("Heard Island and Mcdonald Islands"),
  VA: t("Holy See (Vatican City State)"),
  HN: t("Honduras"),
  HK: t("Hong Kong"),
  HU: t("Hungary"),
  IS: t("Iceland"),
  IN: t("India"),
  ID: t("Indonesia"),
  IR: t("Iran, Islamic Republic Of"),
  IQ: t("Iraq"),
  IE: t("Ireland"),
  IM: t("Isle of Man"),
  IL: t("Israel"),
  IT: t("Italy"),
  JM: t("Jamaica"),
  JP: t("Japan"),
  JE: t("Jersey"),
  JO: t("Jordan"),
  KZ: t("Kazakhstan"),
  KE: t("Kenya"),
  KI: t("Kiribati"),
  KP: t("Korea, Democratic People Republic of"),
  KR: t("Korea, Republic of"),
  KW: t("Kuwait"),
  KG: t("Kyrgyzstan"),
  LA: t("Lao People Democratic Republic"),
  LV: t("Latvia"),
  LB: t("Lebanon"),
  LS: t("Lesotho"),
  LR: t("Liberia"),
  LY: t("Libyan Arab Jamahiriya"),
  LI: t("Liechtenstein"),
  LT: t("Lithuania"),
  LU: t("Luxembourg"),
  MO: t("Macao"),
  MK: t("Macedonia, The Former Yugoslav Republic of"),
  MG: t("Madagascar"),
  MW: t("Malawi"),
  MY: t("Malaysia"),
  MV: t("Maldives"),
  ML: t("Mali"),
  MT: t("Malta"),
  MH: t("Marshall Islands"),
  MQ: t("Martinique"),
  MR: t("Mauritania"),
  MU: t("Mauritius"),
  YT: t("Mayotte"),
  MX: t("Mexico"),
  FM: t("Micronesia, Federated States of"),
  MD: t("Moldova, Republic of"),
  MC: t("Monaco"),
  MN: t("Mongolia"),
  MS: t("Montserrat"),
  MA: t("Morocco"),
  MZ: t("Mozambique"),
  MM: t("Myanmar"),
  NA: t("Namibia"),
  NR: t("Nauru"),
  NP: t("Nepal"),
  NL: t("Netherlands"),
  AN: t("Netherlands Antilles"),
  NC: t("New Caledonia"),
  NZ: t("New Zealand"),
  NI: t("Nicaragua"),
  NE: t("Niger"),
  NG: t("Nigeria"),
  NU: t("Niue"),
  NF: t("Norfolk Island"),
  MP: t("Northern Mariana Islands"),
  NO: t("Norway"),
  OM: t("Oman"),
  PK: t("Pakistan"),
  PW: t("Palau"),
  PS: t("Palestinian Territory, Occupied"),
  PA: t("Panama"),
  PG: t("Papua New Guinea"),
  PY: t("Paraguay"),
  PE: t("Peru"),
  PH: t("Philippines"),
  PN: t("Pitcairn"),
  PL: t("Poland"),
  PT: t("Portugal"),
  PR: t("Puerto Rico"),
  QA: t("Qatar"),
  RE: t("Reunion"),
  RO: t("Romania"),
  RU: t("Russian Federation"),
  RW: t("RWANDA"),
  SH: t("Saint Helena"),
  KN: t("Saint Kitts and Nevis"),
  LC: t("Saint Lucia"),
  PM: t("Saint Pierre and Miquelon"),
  VC: t("Saint Vincent and the Grenadines"),
  WS: t("Samoa"),
  SM: t("San Marino"),
  ST: t("Sao Tome and Principe"),
  SA: t("Saudi Arabia"),
  SN: t("Senegal"),
  CS: t("Serbia and Montenegro"),
  SC: t("Seychelles"),
  SL: t("Sierra Leone"),
  SG: t("Singapore"),
  SK: t("Slovakia"),
  SI: t("Slovenia"),
  SB: t("Solomon Islands"),
  SO: t("Somalia"),
  ZA: t("South Africa"),
  GS: t("South Georgia and the South Sandwich Islands"),
  ES: t("Spain"),
  LK: t("Sri Lanka"),
  SD: t("Sudan"),
  SR: t("Suriname"),
  SJ: t("Svalbard and Jan Mayen"),
  SZ: t("Swaziland"),
  SE: t("Sweden"),
  CH: t("Switzerland"),
  SY: t("Syrian Arab Republic"),
  TW: t("Taiwan, Province of China"),
  TJ: t("Tajikistan"),
  TZ: t("Tanzania, United Republic of"),
  TH: t("Thailand"),
  TL: t("Timor-Leste"),
  TG: t("Togo"),
  TK: t("Tokelau"),
  TO: t("Tonga"),
  TT: t("Trinidad and Tobago"),
  TN: t("Tunisia"),
  TR: t("Turkey"),
  TM: t("Turkmenistan"),
  TC: t("Turks and Caicos Islands"),
  TV: t("Tuvalu"),
  UG: t("Uganda"),
  UA: t("Ukraine"),
  AE: t("United Arab Emirates"),
  GB: t("United Kingdom"),
  US: t("United States"),
  UM: t("United States Minor Outlying Islands"),
  UY: t("Uruguay"),
  UZ: t("Uzbekistan"),
  VU: t("Vanuatu"),
  VE: t("Venezuela"),
  VN: t("Viet Nam"),
  VG: t("Virgin Islands, British"),
  VI: t("Virgin Islands, U.S."),
  WF: t("Wallis and Futuna"),
  EH: t("Western Sahara"),
  YE: t("Yemen"),
  ZM: t("Zambia"),
  ZW: t("Zimbabwe"),
};
